import qs from 'qs';
import instance, { PPR_API_URL } from 'api';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { IServiceLog, IPprLog } from 'pages/PageLogs/interfaces';
import { IDynamicTableParams } from 'components/DynamicTable';

// Service
export const getServiceLogList = (data: IDynamicTableParams) => {
  return instance()
    .post<IServiceLog[]>('/auditLog/list', data)
    .then((response) => response.data);
};

export const getAvailableColumnsService = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/auditLog/availableColumns')
    .then((response) => response.data);
};

export const getAvailableGroupColumnsService = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/auditLog/availableGroupColumns')
    .then((response) => response.data);
};

export const loadServiceLog = (auditLogId: number) => {
  return instance()
    .post<IServiceLog>('/auditLog/load', { auditLogId })
    .then((response) => response.data);
};

// Ppr
export const getPprLogList = (params: IDynamicTableParams) => {
  return instance(true, PPR_API_URL)
    .get<IPprLog[]>('/logAction/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true }),
    })
    .then((response) => response.data);
};

export const getAvailableColumnsPpr = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableColumnModel[]>('/logAction/availableColumns')
    .then((response) => response.data);
};

export const getAvailableGroupColumnsPpr = () => {
  return instance(true, PPR_API_URL)
    .get<IAvailableGroupColumnModel[]>('/logAction/availableGroupColumns')
    .then((response) => response.data);
};

export const loadPprLog = (logId: number) => {
  return instance(true, PPR_API_URL)
    .get<IPprLog>('/logAction/load/' + logId)
    .then((response) => response.data);
};
